export type TPage = PageType;

export enum PageType {
  search = 'search',
  browse = 'browse',
  promo = 'promo',
  valuedeal = 'valuedeal',
}

export enum DL_PID_Type {
  search = 'search',
  category = 'category',
}
